"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Scheduler =
/** @class */
function () {
  function Scheduler(handler, settings, state) {
    this._iteration = 1;
    this.state = {};

    this.handler = function (_i, _state) {};

    this.onStart = function () {};

    this.onEnd = function () {};

    this.settings = settings || Scheduler.DEFAULT_SETTINGS;
    this.handler = handler || this.handler;
    this.state = state || this.state;
  }

  Scheduler.prototype.start = function () {
    var _this = this;

    if (typeof this.settings.iterations === 'undefined' || this.settings.iterations > 0) {
      if (typeof this.settings.iterations === 'undefined') {
        this._interval = setInterval(function () {
          _this.onStart.call(_this, _this.state);

          _this.handler.call(_this, _this._iteration++, _this.state);
        }, this.settings.repeating_time);
      } else {
        this._interval = setInterval(function () {
          _this.run();
        }, this.settings.repeating_time);
      }
    }

    return this;
  };

  ;

  Scheduler.prototype.run = function () {
    if (this._iteration <= this.settings.iterations) {
      this.onStart.call(this, this.state);
      this.handler.call(this, this._iteration++, this.state);
    } else if (this.settings.iterations) {
      this.stop();
    }
  };

  Scheduler.prototype.stop = function () {
    this._iteration--;
    clearInterval(this._interval);
    this.onEnd.call(this, this._iteration, this.state);
  };

  Scheduler.DEFAULT_SETTINGS = {
    repeating_time: 2000,
    iterations: 1
  };
  return Scheduler;
}();

exports.default = Scheduler;